module.exports = __webpack_public_path__ + "static/img/location.6721c25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/location.png
// module id = fLQP
// module chunks = 0